import { render, staticRenderFns } from "./UserCommunities.vue?vue&type=template&id=00461f1b&scoped=true"
import script from "./UserCommunities.js?vue&type=script&lang=js&external"
export * from "./UserCommunities.js?vue&type=script&lang=js&external"
import style0 from "./UserCommunities.scss?vue&type=style&index=0&id=00461f1b&prod&scoped=true&lang=scss&external"
import style1 from "../User.scss?vue&type=style&index=1&id=00461f1b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00461f1b",
  null
  
)

export default component.exports